import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";
const SideBarSupplier = ({notify}) => {

  const { pathname } = useLocation();
  const {user} = useAuth()

  const { t } = useTranslation();
  
  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
          .querySelectorAll(".subdrop + ul")
          .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
          .querySelectorAll(".subdrop + ul")
          .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }
    
    document.addEventListener("mouseover", handleMouseOver);
    
    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);
  
  return (
    <>
    <div className="sidebar" id="sidebar">
    <Scrollbars>
    <div className="sidebar-inner slimscroll">
    <div id="sidebar-menu" className="sidebar-menu">
    <ul className="sidebar-vertical">



      {/* Super */}
      {user.super && <>
    <li className="menu-title">
    <span>Super User</span>
    </li>
    <li >
    <Link to="/super-biodata" className={pathname === "/super-biodata" ? "active" : ""}>
    <i className="fe fe-eye" /> <span>{t("Biodata Log")}</span>{" "}
    </Link>
    </li>

    <li >
    <Link to="/super-deleted-biodata" className={pathname === "/super-deleted-biodata" ? "active" : ""}>
    <i className="fe fe-eye" /> <span>{t("Deleted Vendor Biodata Log")}</span>{" "}
    </Link>
    </li>

    <li>
    <Link to="/super-users" className={(pathname === "/super-users") ? "active" : ""}>
    <i className="fe fe-eye" /> <span>{t("Vendors log")}</span>{" "}
    </Link>
    </li></>}

    {/* Main */}
    <li className="menu-title">
    <span>{t("Biodata")}</span>
    </li>
    <li >
    <Link to="/biodata-form" className={pathname === "/biodata-form" ? "active" : ""}>
    <i className="fe fe-user-plus" /> <span>{t("Add Biodata")}</span>{" "}
    
    </Link>
    </li>



    
    
<li >
                      <Link to="/biodata-form-extract" className={pathname === "/biodata-form-extract" ? "active" : ""}>
                        <i className="fe fe-user-plus" /> <span>{t("Extract Biodata")}</span>{" "}
    
                      </Link>
    </li>


    <li>
    <Link to="/allbiodata" className={(pathname === "/" || pathname === "/dashboard" || pathname === "/allbiodata") ? "active" : ""}>
    <i className="fe fe-users" /> <span>{t("All Biodata")}</span>{" "}
    
    </Link>
    </li>

    

    

     {/* Booking */}
    <li className="menu-title">
    <span>Booking</span>
    </li>
    
    
    {/* <li>
     <Link to="/booking/onhold" className={pathname === "/booking/onhold" ? "active" : ""}>
    <i className="fe fe-pause-circle" /> <span>On-Hold</span>
    </Link>
    </li> */}
    <li>
    <Link style={{display:'flex',alignItems:'center'}} to="/booking" className={pathname === "/booking" ? "active" : ""}>
    <i className="fe fe-book" /> <span>{t("Booking")}</span>
    {pathname !== "/booking" &&notify.book && <span className="badge badge-danger rounded-pill ms-2" style={{
      width: '8px',
      height: '8px',
      backgroundColor: '#dc3545',
      border: 'none',
      padding: '0',
      display: 'inline-block',
  
    }}></span>}
    </Link>
    </li>
    {/*<li>
    <Link to="/booking/pending" className={pathname === "/booking/pending" ? "active" : ""}>
    <i className="fe fe-loader" /> <span>{t("Pending")}</span>
    </Link>
    </li>*/}

  
    
    {/* Agencies */}
    <li className="menu-title">
    <span>{t("Agencies")}</span>
    </li>
    
    
    <li>
    <Link to="/agency-list#" className={pathname === "/agency-list" ? "active" : ""}>
    <i className="fe fe-list" /> <span>{t("Agency list")}</span>
    </Link>
    </li>


  

    {
      user.role == "Admin" && <>
        <li>
        <Link to="/agencies-invitations" className={pathname === "/agencies-invitations" ? "active" : ""}>
        <i className="fe fe-send" /> <span>{t("Invite Agency")}</span>
        </Link>
        </li>
        </>
    }
         <li>
    <Link to="/invite/pending"  style={{display:'flex',alignItems:'center'}}  className={pathname === "/invite/pending" ? "active" : ""}>
    <i className="fe fe-loader" /> <span>{t("Agency Invitations")}</span>
     {pathname !== "/invite/pending" && notify.invited && <span className="badge badge-danger rounded-pill ms-2" style={{
      width: '8px',
      height: '8px',
      backgroundColor: '#dc3545',
      border: 'none',
      padding: '0',
      display: 'inline-block',
  
    }}></span>}
    </Link>
    </li>
    
    {/* Vendor */}     
    {
      user.role == "Admin" && <>
      <li className="menu-title">
      <span>{t("Vendor")}</span>
      </li>

      <li>
      <Link to="/vendor-details" className={pathname === "/vendor-details" ? "active" : ""}>
      <i className="fe fe-info" /> <span>{t("Vendor Details")}</span>
      </Link>
      </li>

      <li>
      <Link to="/staff" className={pathname === "/staff" ? "active" : ""}>
      <i className="fe fe-users" /> <span>{t("Staff Management")}</span>
      </Link>
      </li>

      <li>
      <Link to="/invitations" className={pathname === "/invitations" ? "active" : ""}>
      <i className="fe fe-send" /> <span>{t("Invite Staff")}</span>
      </Link>
      
      </li>
      </>
      }
      
       {/* Help */}
                    
                         <>
                            <li className="menu-title">
                                <span>{t("Support")}</span>
                            </li>
      
                            <li>
                              <Link to="/feedback" className={pathname === "/feedback" ? "active" : ""}>
                                <i className="fe fe-message-circle" /> <span>{t("Feedback")}</span>
                              </Link>
                            </li>
      
                             <li>
                              <Link to="/documentation?type=vendor" className={pathname === "/documentation" ? "active" : ""}>
                                <i className="fe fe-book-open" /> <span>{t("Documentation Vendor")}</span>
                              </Link>
                            </li>

                               <li>
                              <a href="/video-guide/"   target="_blank" 
  rel="noopener noreferrer">
                                <i className="fe fe-play" /> <span>{t("Video Guide")}</span>
                              </a>
                            </li>
                           </> 

      </ul>
      </div>
      </div>
      </Scrollbars>
      </div>
      </>
    );
  };
SideBarSupplier.propTypes = {
    notify: PropTypes.shape({
      book: PropTypes.bool,
      invited: PropTypes.bool,
    }),
  };
  export default SideBarSupplier;